// extracted by mini-css-extract-plugin
export default {"mobileWrapper":"subscriptionFormWrapper-module__mobileWrapper__2HMyS"};